import "./App.css";
import OpenSec from "./components/openSec/OpenSec";
import Header from "./components/header/Header";
import About from "./components/about/About";
import "bootstrap-icons/font/bootstrap-icons.css";
import Services from "./components/services/Services";
import Works from "./components/works/Works";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Recommendations from "./components/recommendations/Recommendations";
import Faq from "./components/faq/Faq";
import Footer from "./components/footer/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import brownWaves from "./media/images/brownWaves.png";
import dudiTalkingVid from "./media/images/dudiTalkingVid.mp4";
import Contact from "./components/contact/Contact";

function App() {
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: false, // Whether animation should happen only once
        });
    }, []);

    return (
        <Router>
            <div
                className="App"
                style={{
                    "--strong": "#2E2E2E",
                    "--weak": "#F8F5F2",
                    "--highlight": "#8B5E3B",
                }}
            >
                <Header />
                <main>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <>
                                    <OpenSec />
                                    <About />
                                    <Services />
                                    <div className="dudiVidDiv">
                                        <h1 className="head">
                                            דוגמה לעבודה עם הסבר{" "}
                                        </h1>
                                        <video
                                            src={dudiTalkingVid}
                                            controls
                                            preload="metadata"
                                        />
                                        <img
                                            className="wave waveBottom"
                                            src={brownWaves}
                                            alt="Brown wave"
                                        />
                                    </div>

                                    <Works />
                                    <Recommendations />
                                    <Faq />
                                    <div
                                        style={{
                                            backgroundColor: "var(--weak)",
                                        }}
                                    >
                                        <img
                                            className="wave waveBottom"
                                            src={brownWaves}
                                            alt="Brown wave"
                                        />
                                    </div>
                                    <Contact />
                                </>
                            }
                        />
                        {/*  <Route
                            path="/accessibility"
                            element={<Accessibility />}
                        /> */}
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
